"use client"

import { BrowserRouter as Router, Routes, Route, Link, Navigate, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import "./App.css"
import { AuthProvider, useAuth } from "./context/AuthContext"

// Páginas
import DashboardPage from "./pages/DashboardPage"
import DisciplinasPage from "./pages/DisciplinasPage"
import TurmasPage from "./pages/TurmasPage"
import SalasPage from "./pages/SalasPage"
import HorariosPage from "./pages/HorariosPage"
import UsuariosPage from "./pages/UsuariosPage"
import ProfessoresPage from "./pages/ProfessoresPage"
import CursosPage from "./pages/CursosPage"
import DptPage from "./pages/DptPage"
import ConfiguracoesPage from "./pages/ConfiguracoesPage"
import InstituicoesPage from "./pages/InstituicoesPage"
import GestaoUsuariosPage from "./pages/GestaoUsuariosPage"

import Login from "./pages/Login"
import Register from "./pages/Register"

// Ícones
import {
  FiHome,
  FiBook,
  FiLayers,
  FiBox,
  FiCalendar,
  FiUsers,
  FiUser,
  FiArchive,
  FiGrid,
  FiSettings,
  FiMenu,
  FiX,
} from "react-icons/fi"

const initializeTheme = () => {
  try {
    const temaSalvo = localStorage.getItem("cajutime-tema") || "padrao"
    if (temaSalvo === "padrao") {
      document.documentElement.removeAttribute("data-theme")
    } else {
      document.documentElement.setAttribute("data-theme", temaSalvo)
    }
  } catch (e) {
    console.error("Error initializing theme:", e)
  }
}

// Initialize theme on load
initializeTheme()

function AppContent() {
  const { user, loading } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const navigate = useNavigate()

  // Listener para logout do AuthContext
  useEffect(() => {
    const handleLogout = () => {
      navigate("/login", { replace: true })
    }
    window.addEventListener("auth-logout", handleLogout)
    return () => window.removeEventListener("auth-logout", handleLogout)
  }, [navigate])

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "cajutime-tema") {
        const novoTema = e.newValue || "padrao"
        if (novoTema === "padrao") {
          document.documentElement.removeAttribute("data-theme")
        } else {
          document.documentElement.setAttribute("data-theme", novoTema)
        }
      }
    }

    window.addEventListener("storage", handleStorageChange)
    return () => window.removeEventListener("storage", handleStorageChange)
  }, [])

  const handleLinkClick = () => {
    setMenuOpen(false)
  }

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev)
  }

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <h2>CajuTime Planner</h2>
          <p>Carregando...</p>
        </div>
      </div>
    )
  }

  return (
    <>
      {user && (
        <header className="top-nav">
          <button className="nav-toggle" onClick={toggleMenu} aria-label="Menu">
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>

          <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
            <Link to="/dashboard" onClick={handleLinkClick}>
              <FiHome /> <span>Dashboard</span>
            </Link>
            <Link to="/disciplinas" onClick={handleLinkClick}>
              <FiBook /> <span>Disciplinas</span>
            </Link>
            <Link to="/turmas" onClick={handleLinkClick}>
              <FiLayers /> <span>Turmas</span>
            </Link>
            <Link to="/salas" onClick={handleLinkClick}>
              <FiBox /> <span>Salas</span>
            </Link>
            <Link to="/horarios" onClick={handleLinkClick}>
              <FiCalendar /> <span>Horários</span>
            </Link>
            <Link to="/usuarios" onClick={handleLinkClick}>
              <FiUsers /> <span>Usuários</span>
            </Link>
            <Link to="/professores" onClick={handleLinkClick}>
              <FiUser /> <span>Professores</span>
            </Link>
            <Link to="/cursos" onClick={handleLinkClick}>
              <FiArchive /> <span>Cursos</span>
            </Link>
            <Link to="/departamentos" onClick={handleLinkClick}>
              <FiGrid /> <span>Departamentos</span>
            </Link>
            <Link to="/configuracoes" onClick={handleLinkClick}>
              <FiSettings /> <span>Configurações</span>
            </Link>
            <Link to="/instituicoes" onClick={handleLinkClick}>
              <FiGrid /> <span>Instituições</span>
            </Link>
            <Link to="/gestao-usuarios" onClick={handleLinkClick}>
              <FiUsers /> <span>Gestão Usuários</span>
            </Link>
          </nav>
        </header>
      )}

      <div className="p-6">
        <Routes>
          {/* Rotas publicas */}
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" replace />} />
          <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" replace />} />

          {/* Rotas protegidas */}
          <Route path="/dashboard" element={user ? <DashboardPage /> : <Navigate to="/login" replace />} />
          <Route path="/disciplinas" element={user ? <DisciplinasPage /> : <Navigate to="/login" replace />} />
          <Route path="/turmas" element={user ? <TurmasPage /> : <Navigate to="/login" replace />} />
          <Route path="/salas" element={user ? <SalasPage /> : <Navigate to="/login" replace />} />
          <Route path="/horarios" element={user ? <HorariosPage /> : <Navigate to="/login" replace />} />
          <Route path="/usuarios" element={user ? <UsuariosPage /> : <Navigate to="/login" replace />} />
          <Route path="/professores" element={user ? <ProfessoresPage /> : <Navigate to="/login" replace />} />
          <Route path="/cursos" element={user ? <CursosPage /> : <Navigate to="/login" replace />} />
          <Route path="/departamentos" element={user ? <DptPage /> : <Navigate to="/login" replace />} />
          <Route path="/configuracoes" element={user ? <ConfiguracoesPage /> : <Navigate to="/login" replace />} />
          <Route path="/instituicoes" element={user ? <InstituicoesPage /> : <Navigate to="/login" replace />} />
          <Route path="/gestao-usuarios" element={user ? <GestaoUsuariosPage /> : <Navigate to="/login" replace />} />

          {/* Rota padrao */}
          <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
          <Route path="*" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
        </Routes>
      </div>
    </>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  )
}
